import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';
import Progress from "../Progress";
import i18next from "i18next";
import Api from "../../../lib/Api";
import Loader from '../../Loader';
// import MoreInfo from "../../../lib/MoreInfo";

class Speed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: '',
            speed: props.speed,
        };

        this.getSpeed = this.getSpeed.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            speed: nextProps.speed,
        });
    }

    componentDidMount() {
        // scroll back to top page
        window.scrollTo(0, 0);
        // Get data from database and store in state
        this.getSpeed();
        i18next.on('languageChanged', () => { this.getSpeed() })

        if (this.props.traject === 'mtb') {
            if (this.props.type === 'Dirtbike' || this.props.type === 'Downhill') {
                this.props.handler('2');
                this.props.goTo('/advice/suspension', this.props.traject);
            }

        }
    }

    render() {
        if (typeof (this.state.data.data) !== "undefined") {
            let handleChange = this.handleChange;
            var self = this;
            var indents = Object.values(this.state.data.data).map(function (item, i) {
                let checked = parseInt(self.state.speed, 10) === item.id;
                return (
                    <div key={item.id} className={"col-12 option option-" + item.id}>
                        {/*<i className="fas fa-info-circle moreInfo" onClick={() => {MoreInfo.show('speed', item[4])}}></i>*/}
                        <div className="row">
                            <div className="col-sm-7" style={{ background: "url(/img/speed_" + item.id + self.props.type + ".jpg)" }}>
                            </div>
                            <div className="col-sm-4 vcenter">
                                <div>
                                    <h3>{item.speed} {item.intro}</h3>
                                    <span>{item.intro2}</span>
                                </div>
                            </div>
                            <div className="col-sm-1 vcenter">
                                <div>
                                    <input type="radio" name="experience" checked={checked} onChange={() => handleChange(item.id)} />
                                </div>
                            </div>
                        </div>
                    </div>


                );
            });

            return (
                <div className="container main">
                    <div className="info-overlay"></div>
                    <div className="more-info">
                        <i className="closeInfo fas fa-times"></i>
                        <div className="more-info-container">

                        </div>
                    </div>

                    <Progress t={this.props.t} goTo={this.props.goTo} step={1} traject={this.props.traject} />
                    <form className="row speed" onSubmit={this.handleSubmit}>
                        <div className="col-12 text-center title">
                            <h2>{this.props.t('Hoe belangrijk is snelheid voor jou?')}</h2>
                            <span className="sub-title">{this.props.t('Wat heeft voor jou prioriteit')}</span>
                        </div>
                        {indents}
                        <div className="col-6 text-left">
                            <button className="back btn btn-link" onClick={this.goBack}><i className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}</button>
                        </div>
                        <div className="col-6 text-right">
                            <input id="submitbtn" className="btn btn-secondary" type="submit" value={this.props.t('Volgende')} />
                        </div>
                    </form>

                </div>
            );

        } else {
            return <Loader />;
        }
    }

    getSpeed() {
        Api.get('/parcour-type/speed', { bike_cat: this.props.traject }).then(response => {
            this.setState({ data: response.data })
        })
    }

    handleChange(value) {
        this.setState({ speed: value });
        document.getElementById("submitbtn").disabled = false;
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.speed === undefined) {
            alert("please provide an answer");
        } else {
            this.props.handler(this.state.speed)
                .then(() => this.props.goTo('/advice/suspension', this.props.traject));
        }
    }
    goBack(event) {
        event.preventDefault();
        this.props.goTo('/advice/usage', this.props.traject);
    }
}

export default withTranslation('speed')(Speed);
